import React from "react";
import { PageTitle } from "../ui/PageTitle";
import "./assets/hujjatlar.scss";
import { useTranslation } from 'react-i18next';
import { api } from "../../host";
function Documents() {
  const {t} = useTranslation();
  return (
    <div className="hujjatlar">
      <div className="container">
        <PageTitle title={t('HUJJATLAR')} />
        <div className="containerr">
       
         <div className="hujjatlar-downloader" style={{display:'flex', justifyContent:'space-between'}}>
           <a href={`${api}/Files/Ustav_new.pdf`} target="_blank">{t('ruleq')}</a>
           <a href={t("check")?"https://lex.uz/ru/docs/-4103217":"https://lex.uz/ru/docs/4103219"} target="_blank">{t('Batafsil')}</a>
        
         </div>
          <div className="hujjatlar-downloader" style={{display:'flex', justifyContent:'space-between'}}>
           <a href={`${api}/Files/Sport.pdf`} target="_blank">{t('sport_ruleq')}</a>
           
         </div>
         
        </div>
      </div>
    </div>
  );
}

export default Documents;
